import React, { useState } from 'react';
import style from './EditTodorForm.module.css';
function EditTodoForm({editTodo,task}) {
  const [value,setValue]=useState(task.task);
    const handleSubmit=(e)=>{
        e.preventDefault();
        editTodo(value,task.id)
    }
  return (
    <form onSubmit={handleSubmit} className={style.todoform}>
        <input type='text'
        value={value}
        onChange={(e)=>{setValue(e.target.value)}}
        className={style.todo_input}
        placeholder='Update Task...'    
        />
        <button type='submit' className={style.todo_btn}>Update</button>
    </form>
  )
}

export default EditTodoForm